module.exports = __webpack_public_path__ + "static/key-swordlegacy-73b0b3b7617972cde1dcf5791d1754b1.webp";